import { PlateElement } from "@platejs/core/react";
import { parseTwitterUrl, parseVideoUrl } from "@platejs/media";
import { useMediaState, MediaEmbedPlugin } from "@platejs/media/react";
import { ResizableProvider, useResizableValue } from "@platejs/resizable";
import { withHOC } from "@platejs/core/react";
import { withRef } from "@udecode/cn";
import { MediaPopover } from "./MediaPopover";

export const MediaEmbedElement = withHOC(
	ResizableProvider,
	withRef<typeof PlateElement>(({ children, className, ...props }, ref) => {
		const { embed, isVideo } = useMediaState({
			urlParsers: [parseTwitterUrl, parseVideoUrl],
		});
		// const width = useResizableValue("width");

		return (
			<PlateElement
				ref={ref}
				style={{
					position: "relative",
					padding: "0.625rem 0",
				}}
				{...props}
			>
				{isVideo ? (
					<div>
						<iframe src={embed?.url} title="embed" allowFullScreen />
					</div>
				) : null}
				{children}
			</PlateElement>
		);
	})
);

MediaEmbedElement.displayName = "MediaEmbedElement";
